import React from "react";
import "../HomePage/HomePage.css";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../HomePage/HomePage.css";
import aboutPhoto from "../../assets/photos/wassim-speaker.jpeg";
import skillsPhoto from "../../assets/photos/wassim-conference.jpeg";
import hobbyPhoto from "../../assets/photos/wassim-bike.jpeg";
import quotePhoto from "../../assets/photos/wassim-quote.jpeg";

function HomePage() {
  const skills = [
    { name: "Project Planning", percentage: 85 },
    { name: "Training", percentage: 70 },
    { name: "Program Management", percentage: 80 },
    { name: "Project Management", percentage: 90 },
    { name: "Research", percentage: 75 },
    { name: "Analysis", percentage: 80 },
    { name: "Program evaluation", percentage: 80 },
  ];

  return (
    <div className="app-container">
      <Header />
      <div className="home-page-container">
        <div id="about" className="about">
          <div className="paragraph">
            <h3>About me</h3>
            <p>
              A Passionate Advocate for Social Impact I'm a dedicated individual
              with a passion for making a positive impact on society. My
              experiences working with NGOs in emergency situations and my role
              as a program manager for youth empowerment and child protection
              programs have equipped me with the skills and knowledge to drive
              meaningful change. Beyond my professional endeavors, I'm committed
              to personal growth and sharing my insights. My YouTube channel is
              a platform where I discuss various topics, including books,
              productivity, sports, cycling, parenting, and social intelligence.
              Currently, I'm excited to be launching my own scholarship and
              financial support program for intermediate and high school
              students in my hometown. This initiative aims to contribute to the
              rebuilding of a new, free Syria. I firmly believe in the power of
              hard work and perseverance. I'm not one to shy away from
              challenges, as I know that the most rewarding journeys often
              involve overcoming obstacles. I strive for excellence in both my
              professional and personal life, constantly seeking opportunities
              for growth and development. As a results-oriented team player, I
              thrive on building strong relationships and fostering
              collaboration. I'm passionate about leading projects and programs
              within the social sector, and I enjoy mentoring and coaching team
              members. I'm also a strong advocate for open communication and
              value the opportunity to learn from others.
            </p>
          </div>
          <div className="photo">
            <img src={aboutPhoto} alt="Wassim as a speaker" />
          </div>
        </div>
        <div id="skills" className="skills">
          <div className="photo">
            <img src={skillsPhoto} alt="Wassim in conference" />
          </div>
          <div className="paragraph">
            <h3>Skills</h3>
            <p>
              As a dedicated advocate for social impact, I possess a unique
              blend of skills and experiences that enable me to drive meaningful
              change. I'm adept at designing, implementing, and evaluating
              social impact programs, with a strong focus on youth empowerment,
              child protection,refugees and vulnerable people in both emergency
              and development situation. My leadership abilities allow me to
              inspire and motivate teams to achieve shared goals. I'm also a
              content creator, producing videos on various topics, from books
              and productivity to sports and parenting. Beyond my professional
              skills, I'm a lifelong learner with a passion for personal growth.
              My resilience, adaptability, and strong work ethic enable me to
              overcome challenges and achieve my goals. I'm committed to making
              a positive impact on the world and inspiring others to do the
              same.
            </p>
          </div>
        </div>
        <div className="skills-precentage-container">
          {skills.map((skill) => {
            return (
              <div key={skill.name} className="skills-container">
                <div className="skill-name">
                  <p>{skill.name}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div id="hobbies" className="about">
          <div className="paragraph">
            <h3>Interests and hobby’s</h3>
            <p>
              I'm a multifaceted individual with a diverse range of interests.
              When I'm not immersed in the world of books or crafting engaging
              content for my YouTube channel, I'm often found exploring the open
              road on my bike. Cycling allows me to connect with nature,
              challenge myself physically, and clear my mind. Beyond cycling,
              I'm passionate about fitness and staying active. Whether it's a
              leisurely bike ride or a more intense workout, I believe in the
              power of physical activity to improve both mental and physical
              well-being. As a parent, I'm constantly learning and growing.
              Sharing insights on parenting and social intelligence is a way for
              me to connect with other parents and contribute to the broader
              community. Ultimately, my hobbies enrich my life and provide a
              balance to my professional pursuits. They allow me to explore my
              creativity, challenge myself, and connect with others on a deeper
              level.
            </p>
          </div>
          <div className="photo">
            <img src={hobbyPhoto} alt="Wassim as a speaker" />
          </div>
        </div>
        <div id="quote-container" className="quote-container">
          <div className="quote-text">
            <p>Where there is will, there is a way.</p>
            <p>Wassim Mahmoud</p>
          </div>
          <div className="photo">
            <img src={quotePhoto} alt="Wassim smiling" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
